import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'leaflet/dist/leaflet.css'
import reportWebVitals from './reportWebVitals';

import {bindActionCreators} from "redux";
import {Provider as ReduxProvider} from "react-redux";
import {clearAuthentication} from "./Config/Reducers/AuthenticationReducer";
import {store, persistor} from "./Config/Store";
import {PersistGate} from 'redux-persist/integration/react';
import {loadIcons} from './Config/IconLoader';
import {SnackbarProvider} from 'notistack';
import { Zoom } from "@mui/material";
import {BrowserRouter} from "react-router-dom";
import {setupInterceptorsTo} from "./Config/AxiosInterceptor";
import RootComponent from "./RootComponent";
import { AuthProvider } from 'react-oidc-context';
import { oidcConfig } from './Config/OidcConfig';

const actions = bindActionCreators({ clearAuthentication }, store.dispatch);
setupInterceptorsTo(() => actions.clearAuthentication('login.error.unauthorized'));
loadIcons();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <AuthProvider {...oidcConfig}>
            <ReduxProvider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <SnackbarProvider
                        maxSnack={5}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        preventDuplicate={true}
                        TransitionComponent={Zoom}
                    >
                        <BrowserRouter>
                            <RootComponent />
                        </BrowserRouter>
                    </SnackbarProvider>
                </PersistGate>
            </ReduxProvider>
        </AuthProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
